import { Dropdown, Option, Tooltip, makeStyles, type DropdownProps } from '@fluentui/react-components';

export const DRAFT_VERSION_VALUE = 'draft';

const useStyles = makeStyles({
  listbox: { minWidth: 0, width: '95px', maxHeight: '200px' },
  dropdown: { minWidth: 0, width: '95px' },
});

type TProps = {
  versions: { id: string }[];
  hasDraft: boolean;
  onOptionSelect: DropdownProps['onOptionSelect'];
  selectedVersion?: string;
  oldestVersionDisabledReason?: string;
};

// Versions come newest first, so the last one is the oldest.
export const VersionDropdown = ({
  versions,
  hasDraft,
  onOptionSelect,
  selectedVersion,
  oldestVersionDisabledReason,
}: TProps) => {
  const classes = useStyles();
  return (
    <Dropdown
      selectedOptions={selectedVersion ? [selectedVersion] : []}
      value={selectedVersion === DRAFT_VERSION_VALUE ? 'Draft' : (selectedVersion ?? 'None')}
      onOptionSelect={onOptionSelect}
      appearance="outline"
      listbox={{ className: classes.listbox }}
      className={classes.dropdown}
    >
      {hasDraft && (
        <Option value={DRAFT_VERSION_VALUE} text="Draft">
          Draft
        </Option>
      )}
      {versions.map(({ id }, index) =>
        oldestVersionDisabledReason && index === versions.length - 1 ? (
          <Tooltip
            key={id}
            content={oldestVersionDisabledReason}
            relationship="description"
            positioning="after"
            withArrow
          >
            <Option value={id} text={id} disabled>
              {id}
            </Option>
          </Tooltip>
        ) : (
          <Option key={id} value={id} text={id}>
            {id}
          </Option>
        )
      )}
    </Dropdown>
  );
};
